import React from 'react';

const BurgerIcon = ({ toggleSidebar }) => {
    return (
        <div className="burger-icon" onClick={toggleSidebar}>
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
        </div>
    );
};

export default BurgerIcon;
